import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import classNames from 'classnames';
import { LISTING_STATE_CLOSED } from '../../../util/types';
import css from './ActionBarMaybe.css';
import ActionBarButton from './ActionBarButton';

export const ActionBarMaybe = ({
    isOwnListing,
    listing,
    clickHandler,
    editParams,
    currentUser,
}) => {
    const { state } = listing.attributes;
    const isClosed = state === LISTING_STATE_CLOSED;

    if (!isOwnListing && !isClosed) return null;

    const { emailVerified, email } = currentUser.attributes;

    const getState = () => (isClosed && isOwnListing ? 'closed-private' : state);

    return (
        <div
            className={classNames(css.actionBar, {
                [css.actionBarEmailUnverified]: email && !emailVerified,
                [css[state]]: Boolean(css[state]),
            })}
            onClick={clickHandler}
        >
            <p className={css.ownListingText}>
                <FormattedMessage id={`ListingPage.actionBar-${getState()}`} />
            </p>
            {isOwnListing && <ActionBarButton listing={listing} editParams={editParams} />}
        </div>
    );
};

export default ActionBarMaybe;
